import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})

export class DashboardComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }

}

export const DashboardSectionStatus = ["Sections up to date", "Sections to review", "Sections to add"];

